import styled from 'styled-components'

import { Refresh2Icon } from '@blade/ui-kit'

type Props = {
  onClick: () => void
}

export const NodeRefreshButton: React.FC<Props> = ({ onClick }) => {
  return (
    <Root onClick={onClick}>
      <Refresh2Icon size={12} />
    </Root>
  )
}

export const Root = styled.button`
  all: unset;
  cursor: pointer;
  color: var(--text-9);
  display: grid;
  place-items: center;

  &:hover {
    color: var(--text-11);
  }
`
